import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelectCompanyService } from 'app/utils/services/selectCompanyService';
import useRedirectWithFormId from 'app/utils/customHooks/useRedirectWithFormId';
import logger from 'app/utils/logger';

const useSelectCompany = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState<undefined | number>();
  const [innOfCompany, setInnOfCompany] = useState<string>();
  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);
  const data = location.state;

  logger.log(data.tab);

  const { isLoadingSelectCompany, dataSelectCompany, selectCompanyMutation } = useSelectCompanyService();

  const { handleSubmit } = useForm({});
  // const { handleRedirect } = useRedirectWithFormId();

  useEffect(() => {
    if (dataSelectCompany !== undefined && dataSelectCompany?.error === undefined) {
      // handleRedirect(dataSelectCompany);
      navigate(`${lang}/home-page`);
      localStorage.setItem('refreshToken', dataSelectCompany?.refresh_token);
    }
  }, [dataSelectCompany]);
  const selectCompany = (index: number, inn: string) => {
    setCurrentIndex(index);
    setInnOfCompany(inn);
  };

  const onSubmit = () => {
    selectCompanyMutation({
      data: { company_inn: innOfCompany },
      url: `${data?.path_url}?business_key=${data?.business_key}`,
    });
  };

  const handleOnSubmit = handleSubmit(onSubmit);

  return { t, isLoadingSelectCompany, currentIndex, selectCompany, handleOnSubmit, data };
};

export default useSelectCompany;
